import { QuoteOptionApiModel } from '~/lib/api/smartsend/types';
import { SumNumber } from './ArrayHelper';
const DEFAULTSHIPPINGCOST = 10;

const GetDeliveredDutyShippingCost = (option: QuoteOptionApiModel): number => {
  if (!option) {
    return DEFAULTSHIPPINGCOST;
  }
  const shippingCost = option.TotalPriceExVat - SumNumber(option.Extras.map((e) => e.Total));
  return shippingCost > 0 ? shippingCost : DEFAULTSHIPPINGCOST;
};
export default GetDeliveredDutyShippingCost;
